module.exports = __webpack_public_path__ + "static/media/roller05.45fadb60.jpeg";